<template>
  <div class="title">{{ desc }}</div>
</template>

<script>
export default {
  props: {
    desc: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  padding: 0 0 20px 0;

  span {
    cursor: pointer;
  }
}
</style>
